import { createFileRoute } from "@tanstack/react-router";
import { Image } from "lucide-react";
import { EmptyState } from "@/components/kit/index.js";

export const Route = createFileRoute("/_authenticated/catalog/media")({
  component: MediaPage,
});

function MediaPage() {
  return (
    <EmptyState
      title="Media"
      description="Media management arrives in a later release. Image uploads for pieces will live here."
      icon={Image}
    />
  );
}
